
export enum PnDRoleCd {
	DISPATCHER = 'Dispatcher',
	PLANNER = 'Planner'}

